<template>
  <header id="header" class="site-header">
    <!-- 桌面导航 -->
    <div class="header-nav hidden-xs">
      <div class="header-inner header-nav-inner">
        <router-link to="/" class="header-logo">
          <img src="@/assets/img/logo.svg" alt="小乐智行">
        </router-link>
        <nav class="nav-main">
          <ul class="nav-list">
            <li
              v-for="(item, index) in navList"
              :key="index"
              class="nav-item"
              :class="{ 'is-active': activeNavIndex === index }"
            >
              <!-- 如果 path 是 javascript:void(0)，使用普通 a 标签 -->
              <a 
                v-if="item.path === 'javascript:void(0)'" 
                href="javascript:void(0)" 
                class="nav-link"
              >
                {{ item.name }}
                <span v-if="item.children.length" class="nav-arrow glyphicon glyphicon-menu-down"></span>
              </a>
              <!-- 否则使用 router-link -->
              <router-link v-else :to="item.path" class="nav-link">
                {{ item.name }}
                <span v-if="item.children.length" class="nav-arrow glyphicon glyphicon-menu-down"></span>
              </router-link>
              <ul v-if="item.children.length" class="nav-dropdown">
                <li v-for="(child, cidx) in item.children" :key="cidx">
                  <router-link :to="child.path" class="nav-dropdown-link">{{ child.name }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!-- 移动端导航 -->
    <div class="header-m visible-xs">
      <div class="header-m-bar">
        <span class="header-m-title">{{ menuName }}</span>
        <button
          type="button"
          class="header-m-toggle"
          aria-label="菜单"
          @click="menuOpen = !menuOpen"
        >
          <span :class="menuOpen ? 'glyphicon glyphicon-remove' : 'glyphicon glyphicon-menu-hamburger'"></span>
        </button>
      </div>
      <div class="header-m-menu" :class="{ open: menuOpen }">
        <ul class="header-m-list">
          <template v-for="(item, index) in navList">
            <li :key="'nav-' + index" class="header-m-item">
              <!-- 如果 path 是 javascript:void(0)，使用普通 a 标签 -->
              <a 
                v-if="item.path === 'javascript:void(0)'"
                href="javascript:void(0)"
                class="header-m-link"
                @click="menuOpen = false"
              >
                {{ item.name }}
              </a>
              <!-- 否则使用 router-link -->
              <router-link
                v-else
                :to="item.path"
                class="header-m-link"
                :class="{ active: activeNavIndex === index && !item.children.length }"
                @click.native="menuOpen = false; navClick(index, item.name)"
              >
                {{ item.name }}
              </router-link>
            </li>
            <li
              v-for="(child, cidx) in item.children"
              :key="'sub-' + index + '-' + cidx"
              class="header-m-sub"
            >
              <router-link
                :to="child.path"
                class="header-m-link"
                :class="{ active: $route.path === child.path }"
                @click.native="menuOpen = false; menuName = child.name"
              >
                {{ child.name }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      menuName: "首页",
      menuOpen: false,
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "解决方案",
          path: "javascript:void(0)",
          children: [
            {
              name: "车路协同数字孪生沙盘系统",
              path: "/product/sandbox"
            },
            {
              name: "DeepCar 自动驾驶机器人",
              path: "/product/deepcar"
            },
            {
              name: "DeepCar Pro 室外无人驾驶机器人",
              path: "/product/deepcar-pro"
            },
            {
              name: "路侧感知与 V2X 中控平台",
              path: "/product/v2x"
            },
            {
              name: "AutoSim 智能车仿真系统",
              path: "/product/autosim"
            },
            {
              name: "智慧交通教学实训方案",
              path: "/product/education"
            }
          ]
        },
        {
          name: "一站式人工智能教学平台",
          path: "/product/ai-platform",
          children: []
        },
        {
          name: "客户案例",
          path: "/cases",
          children: []
        },
        {
          name: "产品资料",
          path: "/downloads",
          children: []
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  computed: {
    activeNavIndex() {
      const path = this.$route.path;
      if (path === "/" || path === "/home") return 0;
      // 解决方案：匹配所有产品页面
      if (path.startsWith("/product/")) {
        // 一站式人工智能教学平台单独处理
        if (path === "/product/ai-platform") return 2;
        return 1;
      }
      if (path === "/cases") return 3;
      if (path.startsWith("/downloads")) return 4;
      if (path === "/companyintroduction") return 5;
      if (path === "/contactus") return 6;
      return 0;
    }
  },
  watch: {
    $route() {
      this.updateMenuName();
    }
  },
  mounted() {
    this.updateMenuName();
  },
  methods: {
    updateMenuName() {
      const path = this.$route.path;
      if (path.startsWith("/downloads")) {
        this.menuName = "产品资料";
      } else {
        this.menuName = this.navList[this.activeNavIndex].name;
      }
    },
    navClick(index, name) {
      this.menuName = name;
    }
  }
};
</script>
<style scoped>

/* 顶部 */
.site-header {
  background: #fff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
.header-nav { height: 64px; }
.header-nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.header-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 60px;
  max-width: 160px;
}
.header-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left center;
}
.nav-main {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 0;
}
.nav-list {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.nav-item {
  position: relative;
  flex-shrink: 0;
}
.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  text-decoration: none;
  border-radius: 8px;
  transition: color 0.2s, background 0.2s;
}
.nav-link:hover {
  color: #0ea5e9;
  background: #f1f5f9;
  text-decoration: none;
}
.nav-item.is-active .nav-link {
  color: #0ea5e9;
  font-weight: 700;
  outline: none;
  box-shadow: none;
}
.nav-arrow {
  font-size: 10px;
  margin-left: 2px;
  transition: transform 0.2s;
}
.nav-item:hover .nav-arrow { transform: rotate(180deg); }
.nav-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  /* 增加伪元素桥接，防止鼠标移动时失去hover */
  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 8px;
  }
}
.nav-item:hover .nav-dropdown { display: block; }
.nav-dropdown li { margin: 0; }
.nav-dropdown-link {
  display: block;
  padding: 10px 16px;
  font-size: 13px;
  color: #475569;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}
.nav-dropdown-link:hover {
  background: #f1f5f9;
  color: #0ea5e9;
  text-decoration: none;
}
.header-m {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}
.header-m-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;
}
.header-m-title {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
}
.header-m-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 20px;
  border-radius: 8px;
  cursor: pointer;
}
.header-m-toggle:hover {
  background: #f1f5f9;
  color: #334155;
}
.header-m-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f8fafc;
}
.header-m-menu.open {
  max-height: 90vh;
  overflow-y: auto;
}
.header-m-list {
  margin: 0;
  padding: 8px 0;
  list-style: none;
  border-top: 1px solid #e2e8f0;
}
.header-m-item,
.header-m-sub {
  margin: 0;
  border-bottom: 1px solid #e2e8f0;
}
.header-m-item:last-child,
.header-m-sub:last-child { border-bottom: none; }
.header-m-link {
  display: block;
  padding: 14px 16px;
  font-size: 15px;
  color: #334155;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}
.header-m-sub .header-m-link {
  padding-left: 32px;
  font-size: 14px;
  color: #64748b;
}
.header-m-link:hover {
  background: #f1f5f9;
  color: #0ea5e9;
  text-decoration: none;
}
.header-m-link.active {
  background: #f0f9ff;
  color: #0ea5e9;
  font-weight: 500;
}

/* 断点：与 Bootstrap 一致，确保桌面/移动只显示对应导航 */
@media (min-width: 768px) {
  .header-m {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .header-nav {
    display: none !important;
  }
  .header-m {
    display: block !important;
  }
}
</style>
<style>
/* 非 scoped：强制桌面导航横排，避免被 reset/其它全局样式覆盖 */
#header.site-header .header-nav .header-nav-inner {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}
#header.site-header .header-nav .nav-main {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
}
#header.site-header .header-nav .nav-main .nav-list {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  margin: 0 !important;
  padding: 0 !important;
  list-style: none !important;
}
#header.site-header .header-nav .nav-main .nav-list > .nav-item {
  display: inline-block !important;
  flex-shrink: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue